import React from 'react';

interface AccountAgreementCheckboxProps {
    name: string;
    checked: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    label: React.ReactNode;
    required?: boolean;
}

export const AccountAgreementCheckbox: React.FC<AccountAgreementCheckboxProps> = ({
    name,
    checked,
    onChange,
    onBlur,
    label,
    required = false,
}) => (
    <label
        data-required-consent={required || undefined}
        className="flex min-h-[5.6rem] cursor-pointer items-center gap-[1rem] rounded-[2.8rem] bg-[#d9cdc5]/20 transition-colors hover:bg-[#d9cdc5]/40 px-[2.7rem] py-[1.6rem] text-[1.5rem] font-normal leading-[2.4rem] text-web-copy"
    >
        <span className="relative flex shrink-0">
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={onChange}
                onBlur={onBlur}
                aria-required={required || undefined}
                className="peer m-0 h-[2.1rem] w-[2.1rem] cursor-pointer appearance-none rounded-[0.6rem] border border-[#d9cdc5] bg-transparent transition-colors checked:border-brand-secondary checked:bg-brand-secondary hover:border-web-copy focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary"
            />
            <svg
                aria-hidden="true"
                viewBox="0 0 16 16"
                fill="none"
                className="pointer-events-none absolute left-1/2 top-1/2 h-[1.4rem] w-[1.4rem] -translate-x-1/2 -translate-y-1/2 text-white opacity-0 peer-checked:opacity-100"
            >
                <path
                    d="m3 8 3.2 3.2L13 4.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
        <span className="min-w-0">{label}</span>
    </label>
);
